<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $tc('add') }} {{ $t('vendormapping') }}</div>
      <router-link class="btn-blue" to="vendor-mapping">{{ $tc('vendor', 1) }} {{ $tc('list',2) }}</router-link>
    </div>

    <section class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedCinema.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('cinema',2) }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
                name="mapcinema"
                id="mapcinema"
              >
                <b-dropdown-item
                  v-for="(cinema, cinemaKey) in Cinemas"
                  :key="cinemaKey"
                  v-on:click="onSelectCinema(cinema.cine_id, cinema.cine_name)"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('vendorMapping_selectCinema')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0">Please Select Cinema.</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="SelectedVendor.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('vendor', 1) }}</label>
              <b-dropdown
                :text="SelectedVendor"
                variant="dropdown-curve"
                class="w-100"
                name="mapvendor"
                id="mapvendor"
              >
                <b-dropdown-item
                  v-for="(vendor, vendorKey) in Vendors"
                  :key="vendorKey"
                  v-on:click="onSelectVendor(vendor)"
                >{{ vendor.v_name }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('vendorMapping_selectVendor')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && SelectedVendor.length == 0">Please Select Vendor.</span>
          </p>
        </div>

        <div v-for="(list,listKey) in selectedRawMaterials" :key="listKey" class="col-md-12 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container mr-2">
              <label :class="list.name.length > 0 ? 'shift-up' : '' ">{{ $tc('rawmaterials', 1) }}</label>
              <b-dropdown :text="list.name" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(raw, rawKey) in RawMaterials"
                  :key="rawKey"
                  v-on:click="onSelectRawMaterial(raw,listKey)"
                >{{ raw.rm_name }}</b-dropdown-item>
              </b-dropdown>
              <p class="error_message">
                <span v-if="submitted && list.name.length == 0">Please Select Raw Material.</span>
              </p>
            </div>

            <div class="input-material mr-2">
              <input
                v-model="list.vr_qty"
                type="text"
                name="mapquantity"
                id="mapquantity"
                v-validate="'required|numeric'"
              />
              <label>{{ $t('quantity') }}</label>
              <p class="error_message">
                <span
                  v-if="submitted && errors.has('mapquantity')"
                >{{ errors.first('mapquantity') }}</span>
              </p>
            </div>

            <div class="dropdown-curve-container mr-2">
              <label :class="list.uom_unit.length > 0 ? 'shift-up' : '' ">UOM</label>
              <b-dropdown :text="list.uom_unit" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(uom, uomKey) in UomList"
                  :key="uomKey"
                  v-on:click="onSelectUnitOfM(uom,listKey)"
                >{{ uom.uom_unit }}</b-dropdown-item>
              </b-dropdown>
              <p class="error_message">
                <span
                  v-if="submitted && list.uom_unit.length == 0"
                >Please Select Unit of Measurement.</span>
              </p>
            </div>

            <div class="input-material mr-2">
              <input
                v-model="list.vr_rate"
                type="text"
                name="rate"
                id="rate"
                v-validate="'required|numeric'"
              />
              <label>{{ $t('rate') }}</label>
              <p class="error_message">
                <span v-if="submitted && errors.has('rate')">{{ errors.first('rate') }}</span>
              </p>
            </div>

            <div class="col-md-2 text-center">
              <button
                class="btn-transparent"
                v-if="listKey === 0"
                @click.prevent.stop="increaseRow()"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button v-else @click.prevent.stop="decreaseRow(listKey)" class="btn-transparent">
                <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('isdefaultvendor') }}</label>
            <label class="ios-switch ml-2">
              <input v-model="rmv_is_default_vendor" type="checkbox" class="ios-checkbox" checked />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <label class="ios-switch ml-2">
              <input v-model="rmv_is_active" type="checkbox" class="ios-checkbox" checked />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit()" class="btn-blue">{{ $t('save') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="vendor-mapping"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      isRoleID: true,
      submitted: false,
      rmv_is_active: true,
      rmv_is_default_vendor: true,
      vendor_id: "",
      cinema_id: "",

      SelectedVendor: "",
      selectedCinema: "",
      selectedRawMaterial: "",
      selectVendorOptions: ["India", "UAE", "USA", "UK", "China", "Sri Lanka"],
      Cinemas: [],
      UomList: [],
      Vendors: [],
      RawMaterials: [],
      selectedRawMaterials: [
        {
          name: "",
          rm_id: "",
          vr_qty: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: "",
          vr_is_active: true
        }
      ]
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
  },
  mounted() {
    this.getVendorsList();
    this.getRawMaterials();
    this.getUoM();
  },
  methods: {
    increaseRow: function() {
      this.selectedRawMaterials.push({
        name: "",
        rm_id: "",
        vr_qty: "",
        uom_id: "",
        uom_unit: "",
        vr_rate: "",
        vr_is_active: true
      });
    },
    decreaseRow: function(index) {
      this.selectedRawMaterials.splice(index, 1);
    },
    onSelectCinema: function(cine_id, cine_name) {
      this.selectedCinema = cine_name;
      this.cinema_id = cine_id;
    },
    onSelectRawMaterial: function(params, index) {
      this.selectedRawMaterials[index].name = params.rm_name;
      this.selectedRawMaterials[index].rm_id = params.rm_id;
    },
    onSelectUnitOfM: function(params, index) {
      this.selectedRawMaterials[index].uom_id = params.uom_id;
      this.selectedRawMaterials[index].uom_unit = params.uom_unit;
    },
    onSelectVendor: function(params) {
      this.SelectedVendor = params.v_name;
      this.vendor_id = params.v_id;
    },
    getUoM: function() {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getCinemasList: function(cine_id) {
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                this.onSelectCinema(x.cine_id, x.cine_name);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getVendorsList: function() {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getRawMaterials: function() {
      let payload = {
        tableName: "ms_raw_materials",
        rm_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          let payload = {
            cinema_id: this.cinema_id,
            vendor_id: this.vendor_id,
            rmv_is_default_vendor:
              this.rmv_is_default_vendor == true ? "Y" : "N",
            rmv_is_active: this.rmv_is_active == true ? "Y" : "N",
            selectedRawMaterials: this.selectedRawMaterials
          };
          PosFnbService.AddVendorMapping(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "vendor-mapping"
                });
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/addVendorMapping.vue